import type { PaymentPortalURL } from "@/api";

/**
 * Checks if the response has an error.
 * @param response - The response to check.
 * @returns True if the response has an error, false otherwise.
 */
export function hasError(response: PaymentPortalURL): boolean {
  return response.statusCode !== 200;
}
